import * as Yup from "yup";

// Common Email Validation Rule
const emailValidation = Yup.string()
  .trim()
  .email("Please enter a valid email")
  .required("Please enter email")
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
    "Please enter a valid email",
  );

// Common Password Validation Rule
const passwordValidation = Yup.string()
  .required("Please enter password")
  .min(8, "Password cannot be less than 8 characters")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
    "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.",
  );

// Common File Validation Rule
const fileValidation = Yup.mixed()
  .test("fileType", "Please upload a valid image", (value) => {
    if (!value || typeof value === "string") return true;
    const validFileTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
    ];
    return validFileTypes.includes(value.type);
  })
  .test("fileSize", "File size must be less than or equal to 10MB", (value) => {
    if (!value || typeof value === "string") return true;
    const maxSizeInBytes = 10 * 1024 * 1024;
    return value.size <= maxSizeInBytes;
  })
  .required("Please upload an image");

// Sign In Schema
export const signInSchema = Yup.object().shape({
  identifier: Yup.string()
    .required("Please enter email / phone")
    .test(
      "is-valid-identifier",
      "Please enter a valid email / phone",
      function (value) {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const phoneRegex = /^[0-9]{7,15}$/; // 7–15 digits (international safe range)

        return emailRegex.test(value) || phoneRegex.test(value);
      },
    ),
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less than 8 characters"),
});
// Sign Up Schema
export const signUpSchema = Yup.object().shape({
  identifier: Yup.string()
    .required("Please enter email / phone")
    .test(
      "is-valid-identifier",
      "Please enter a valid email / phone",
      function (value) {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const phoneRegex = /^[0-9]{7,15}$/; // 7–15 digits (international safe range)

        return emailRegex.test(value) || phoneRegex.test(value);
      },
    ),
  full_name: Yup.string()
    .required("Please enter full name")
    .min(3, "Full name must be at least 3 characters long")
    .trim(),
  acceptTerms: Yup.boolean()
    .oneOf([true], "You must accept Terms & Conditions")
    .required("You must accept Terms & Conditions"),
});
// forgot password Schema
export const forgotPasswordSchema = Yup.object().shape({
  identifier: Yup.string()
    .required("Please enter email / phone")
    .test(
      "is-valid-identifier",
      "Please enter a valid email / phone",
      function (value) {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const phoneRegex = /^[0-9]{7,15}$/; // 7–15 digits (international safe range)

        return emailRegex.test(value) || phoneRegex.test(value);
      },
    ),
});

export const changePasswordSchema = Yup.object().shape({
  new_password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less than 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.",
    ),
  confirm_password: Yup.string()
    .required("Please enter confirm password")
    .oneOf([Yup.ref("new_password"), null], "Your password must match"),
});

export const helpSupportSchema = Yup.object().shape({
  full_name: Yup.string()
    .trim()
    .required("Please enter full name")
    .min(3, "Full name must be at least 3 characters long"),
  email: emailValidation,
  message: Yup.string()
    .trim()
    .required("Please enter message")
    .min(10, "Message must be at least 10 characters long")
    .max(1000, "Message cannot exceed 1000 characters"),
});
